export interface BloomAnimation {
	animationName: string;
	bloomDrift: string;
	bloomTilt: string;
	bloomRotation: string;
	bloomDistance: string;
}

export const BLOOM_ANIMATION_NAME = 'omnibar-bloom';

export const createBloomAnimation = (
	randomDrift: number,
	randomTilt: number,
	randomRotation: number,
	randomDistance: number,
): BloomAnimation => ({
	animationName: BLOOM_ANIMATION_NAME,
	bloomDrift: `${randomDrift}px`,
	bloomTilt: `${randomTilt}deg`,
	bloomRotation: `${randomRotation}deg`,
	bloomDistance: `${randomDistance}px`,
});
